let newReplyToWatch = null
let newReplyProspect = null
let newReplyUser = null
let newReplyIsAnonymous = null
let newReplyIsModerator = null
let newReplyAnonymousId = null

let responsePath = null

const listeners = []

export default {
  setResponsePath({ responsePath: path }) {
    responsePath = [...path]
    listeners.forEach((listener) => listener())
  },
  get responseToWatch() {
    return responsePath?.[0] || null
  },
  isWatchingResponse({ responseId }) {
    return this.responseToWatch === responseId
  },
  get hasChild() {
    return !!responsePath?.[1]
  },
  removeResponse({ responseId }) {
    if (responseId === this.responseToWatch) {
      responsePath.splice(0, 1)
    }
    if (responsePath?.length === 0) {
      responsePath = null
    }
  },
  setNewReplyToWatch({ newReplyId, prospect, user, anonymousId, isAnonymous, isModerator }) {
    newReplyToWatch = newReplyId
    newReplyProspect = prospect
    newReplyAnonymousId = anonymousId
    newReplyUser = user
    newReplyIsAnonymous = isAnonymous
    newReplyIsModerator = isModerator
    listeners.forEach((listener) => listener())
  },
  isWatchingNewReply({ newReplyId }) {
    return newReplyToWatch === newReplyId
  },
  newReplyProspect() {
    return newReplyProspect
  },
  newReplyUser() {
    return newReplyUser
  },
  newReplyAnonymousId() {
    return newReplyAnonymousId
  },
  newReplyIsAnonymous() {
    return newReplyIsAnonymous
  },
  newReplyIsModerator() {
    return newReplyIsModerator
  },
  removeAll() {
    responsePath = null
    newReplyToWatch = null
    newReplyProspect = null
    newReplyAnonymousId = null
    newReplyUser = null
    newReplyIsAnonymous = null
    newReplyIsModerator = null
  },
  get newReplyToWatch() {
    return newReplyToWatch
  },
  addListener({ callback }) {
    listeners.push(callback)
  },
  removeListener({ callback }) {
    listeners.splice(listeners.indexOf(callback), 1)
  }
}
